import {useTranslation} from 'react-i18next';
import {cn} from '@chekin/guestapp-ui-kit';
import {ButtonProps} from '@chekinapp/ui';
import {ButtonConfirm, Text, Wrapper, BodyImage, StyledLottie} from './styled';

type StandardModalButtonProps = ButtonProps;

export type StandardModalSheetProps = {
  text?: string | JSX.Element | JSX.Element[];
  buttons?: StandardModalButtonProps[];
  img?: string;
  lottie?: object | null;
  className?: string;
  content?: JSX.Element | JSX.Element[];
};
function StandardModalSheet({
  text,
  img,
  lottie,
  buttons,
  className,
  content,
}: Readonly<StandardModalSheetProps>) {
  const {t} = useTranslation();

  return (
    <Wrapper className={cn(className, 'standard-modal-sheet', 'kiosko:mt-8')}>
      {text && (
        <Text className="standard-modal-sheet__text kiosko:text-kiosko-m kiosko:mb-[114px]">
          {text}
        </Text>
      )}
      {content && content}
      {img && <BodyImage className="standard-modal-sheet__image" src={img} />}
      {lottie && <StyledLottie animationData={lottie} />}
      {buttons
        ? buttons.map((buttonProps, index) => {
            const label =
              typeof buttonProps.children === 'string'
                ? t(buttonProps?.children as string)
                : buttonProps.children;

            return (
              <ButtonConfirm
                className={cn(
                  'standard-modal-sheet__button',
                  'kiosko:h-[114px] kiosko:rounded-[56px] kiosko:text-kiosko-m kiosko:w-[698px] kiosko:max-w-none kiosko:mb-[56px]',
                )}
                key={index}
                {...buttonProps}
              >
                {label}
              </ButtonConfirm>
            );
          })
        : null}
    </Wrapper>
  );
}

export {StandardModalSheet};
